
export interface DebouncerParams {
   /** debounce time value */
   debounce?: number
}
export default class Debouncer {
   timeout?: NodeJS.Timeout
   private params

   constructor(params: DebouncerParams = {}) {
      this.params = params
   }

   run = (func: () => any, debounce?: number) => {
      this.clear()
      this.timeout = setTimeout(() => {
         this.timeout = undefined
         func()
      }, debounce ?? this.params.debounce ?? 300)
   }

   clear = () => {
      if (!!this.timeout) {
         clearTimeout(this.timeout)
         this.timeout = undefined
      }
   }
}
